import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination, Autoplay} from 'swiper/modules'
import 'swiper/css';

export default ({onNext}) => {
    return (
        <>
            <div className="page-title">How to pay with CashApp?</div>
            <div className="page-descriptions">Check out the information below</div>

            <form onSubmit={e => {
                e.preventDefault();
                onNext();
            }}>

                <div className="slider guide">
                    <Swiper 
                        modules={[Pagination, Autoplay]}
                        pagination={{
                            el: '.dots',
                            clickable: true,
                            renderBullet: (index, className) => {
                                return `<div class="dot ${className}" data-index="${index}"></div>`
                            }
                        }}
                        autoplay={{
                            delay: 5e3
                        }}
                        speed={500}
                        slidesPerGroup={1}
                        slidesPerView={1}>
                        <SwiperSlide>
                            <div className="guide-tab">
                                <img src={`${window.location.origin}/images/cashapp-guide/btcgift1.png`} />
                                <span>Find Bitcoin section on home screen and tap on it</span>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="guide-tab">
                                <img src={`${window.location.origin}/images/cashapp-guide/btcgift2.png`} />
                                <span>Scroll down to "Ways to use Bitcoin" and select Bitcoin Gifting</span>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="guide-tab">
                                <img src={`${window.location.origin}/images/cashapp-guide/btcgift3.png`} />
                                <span>Enter the amount and the recipient's tag</span>
                            </div>
                        </SwiperSlide>
                    </Swiper>

                    <div className="dots">

                    </div>
                </div>

                <button className="button blue" type="submit">Make deposit</button>
            </form>
        </>
    )
}